const data = {
  pageName: "FixedPlansConfigurator",
  services: {
    translations: {
      url: "fixedPlansConfigurator/translations",
      params: {}
    },
    data: {
      url: "fixedPlansConfigurator/data",
      params: {}
    },
    c2cServiceEnabled: {
      url: "fixedPlansConfigurator/c2cServiceEnabled",
      params: {}
    }
  },
  externalLinks: {
    retentionFixed:
      "/ananeosi-statheris?i_source=mk-fm-banner&i_medium=banners&i_owner=bg-rtp&i_name=20220203-cbu-retention-fixed",
    allPlans: "/eshop/vodafone-home/c-120130/",
    allPlans_24: "/eshop/adsl/c-120112/",
    allPlans_50: "/eshop/50mbps/c-120113/",
    allPlans_100: "/giga-fiber/c-120127/",
    allPlans_200: "/giga-fiber/c-120127/",
    allPlans_300: "/giga-fiber/c-120127/",
    allPlans_500: "/giga-fiber/c-120127/",
    allPlans_1000: "/giga-fiber/c-120127/",
  }
};

exports.data = data;
